export const LABEL_TH ={
    tel: 'โทร',
    email: 'อีเมล์',
    address: 'ที่อยู่',
    followUs: 'ช่องทางติดตาม',
    contactUs: 'ติดต่อเรา',
    lastNews: 'ข่าวล่าสุด',
    gallery: 'รูปภาพ'
}

export const LABEL_EN ={
    tel: 'Tel',
    email: 'E-mail',
    address: 'Address',
    followUS: 'Follow Us',
    contactUs: 'Contact Us',
    lastNews: 'Last News',
    gallery: 'Gallery'
}


// WEBPACK FOOTER //
// ./src/app/mokup/label.ts